(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bi-features"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded', () => {
     document.querySelectorAll('.bi-fea__wrap').forEach(section => {
       section.querySelectorAll('.bi-fea__tab-btn').forEach(btn => {
         btn.addEventListener('click', () => {
           const block = section.querySelector('[data-id="' + btn.dataset.blockId + '"]');
           if (!block) return;

           section.querySelectorAll('.bi-fea__tab-btn').forEach(s_btn => {
             if (s_btn.dataset.blockId === btn.dataset.blockId) {
                s_btn.classList.add('is-active-btn');
             } else {
                s_btn.classList.remove('is-active-btn');
             }
           })
  
           section.querySelectorAll('[data-id]').forEach(block => {        
             if (block.dataset.id === btn.dataset.blockId) {
               block.setAttribute('aria-hidden', 'false');
               block.classList.add('is-visible-section');
             } else {
               block.setAttribute('aria-hidden', 'true');
               block.classList.remove('is-visible-section');
             }
           })
         })
       })
     })
   })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dog-cat-slider"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener('DOMContentLoaded', () => {  
    function finalizeHide(section) {
      section.style.display = 'none';
    }

    function updateSectionVisibility(activeAnimal, animalSections) {
      animalSections.forEach(section => {
        const isTargetSection = section.dataset.animalSection === activeAnimal;
  
        if (isTargetSection) {
          section.setAttribute('aria-hidden', 'false');
          section.style.display = 'block';
  
          setTimeout(() => {
            section.classList.add('is-visible-section');
          }, 20);
  
        } else {
          section.setAttribute('aria-hidden', 'true');
  
          if (section.classList.contains('is-visible-section')) {
            section.classList.remove('is-visible-section');
  
            if (section._transitionEndHandler) {
              section.removeEventListener('transitionend', section._transitionEndHandler);
            }
  
            section._transitionEndHandler = (event) => {
              if (event.target === section && event.propertyName === 'opacity') {
                if (!section.classList.contains('is-visible-section')) {
                  finalizeHide(section);
                }
  
                section.removeEventListener('transitionend', section._transitionEndHandler);
                delete section._transitionEndHandler;
              }
            };
            section.addEventListener('transitionend', section._transitionEndHandler);
  
          } else if (section.style.display !== 'none') {
            finalizeHide(section);
          }
        }
      });
    }
      
    function setActiveButton(animalType, toggleButtons) {
       toggleButtons.forEach(button => {
        if (button.dataset.animalTarget === animalType) {
          button.classList.add('is-active');
        } else {
          button.classList.remove('is-active');
        }
      });
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        aniLogic('#' + event.target.id + ' .bi-ani__wrap');
      });
    }

    function aniLogic(target) {
      document.querySelectorAll(target || '.bi-ani__wrap').forEach(node => {
        const carouselElement = node.querySelector('.bi-ani__slider');
        if (!carouselElement) return;
  
        const allSlides = Array.from(carouselElement.querySelectorAll('.bi-ani__slide'));
        const animalSections = document.querySelectorAll('[data-animal-section]');
  
        let currentAnimalType = node.dataset.activeTab;
        const toggleButtons = node.querySelectorAll('[data-animal-target]');
        const variantSelects = node.querySelectorAll('[data-variant-select]')
  
        let flkty;
  
        function filterAndReinitFlickity(animalType, allSlides, carouselElement) {
          allSlides.forEach(slide => {
            slide.classList.remove('is-loaded');
            if (slide.dataset.animalType === animalType) {
              slide.style.display = '';
            } else {
              slide.style.display = 'none';
            }
          });

          if (animalType === 'dog') {
            carouselElement.style.marginRight = window.innerWidth < 1024 ? '-20px' : window.innerWidth < 1366 ? '-30px' : '-64px';
          } else {
            carouselElement.style.marginRight = window.innerWidth >= 1024 && window.innerWidth < 1366 ? '-30px' : '0'
          }
      
          if (flkty) {
            flkty.destroy();
          }
      
          flkty = new window.theme.Flickity(carouselElement, {
            cellSelector: '.bi-ani__slide',
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            on: {
              ready: function() {
                setTimeout(() => {
                  this.slides.forEach(slide => {
                    slide.outerWidth !== 0 && slide.cells.forEach(cell => cell.element.classList.add('is-loaded'));
                  });
                }, 50);
              }
            }
          });
        }
      
        toggleButtons.forEach(button => {
          button.addEventListener('click', () => {
            const selectedAnimalType = button.dataset.animalTarget;
            
            if (selectedAnimalType !== currentAnimalType || !flkty) {
              currentAnimalType = selectedAnimalType;
              
              setActiveButton(currentAnimalType, toggleButtons);
              
              filterAndReinitFlickity(currentAnimalType, allSlides, carouselElement);
              
              if (animalSections) {
                updateSectionVisibility(currentAnimalType, animalSections);
              }
            }
          });
        });

        variantSelects.forEach(select => {
          select.addEventListener('change', () => {
            const selectedOption = select.options[select.selectedIndex];
            
            const p_slide = select.closest('.bi-ani__slide')
            if (!p_slide) return;

            const priceNode = p_slide.querySelector('.bi-ani__slide-price-or');
            if (!priceNode) return;
            priceNode.textContent = selectedOption.dataset.price;

            const testPriceNode = p_slide.querySelector('.bi-ani__slide-price-test');
            if (!testPriceNode) return;
            testPriceNode.textContent = selectedOption.dataset.testPrice;
          });
        });
      
        setActiveButton(currentAnimalType, toggleButtons);
        filterAndReinitFlickity(currentAnimalType, allSlides, carouselElement);
        
        if (animalSections) {
          updateSectionVisibility(currentAnimalType, animalSections);
        }
      });
    }
    
    aniLogic()
  });

  } catch(e) { console.error(e); }
})();
})();
